/**
 * API 베이스 URL: 브라우저에서 실행 시 호스트에 따라 결정
 * - 로컬(ng serve): 프론트는 :4200 등, API는 PHP 서버 :8092
 * - 실서버 등: 같은 오리진(https://fms.krasi.or.kr)으로 API 호출 (CORS·Mixed Content 방지)
 */
function resolveBaseUrl(): string {
  if (typeof window === 'undefined' || !window.location) {
    return 'https://fms.krasi.or.kr';
  }
  const h = window.location.hostname;
  if (h === 'localhost' || h === '127.0.0.1') {
    return 'http://localhost:8092';
  }
  return `${window.location.protocol}//${window.location.host}`;
}

const baseURL = resolveBaseUrl();
const hrmsURL = 'https://hrms.krasi.or.kr';

export const config = {
  production: typeof window !== 'undefined' && !!window.location &&
    window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1',
  baseUrl: baseURL,
  hrmsUrl: hrmsURL,
  apiBaseUrl: baseURL + "/api",
  apiFileUploadUrl: baseURL + "/api/file/file_upload.php",
  apiImageUploadUrl: baseURL + "/api/file/image_upload.php",
  cookie_token: 'fmstoken'
};
